<script>

export default {
    name: "OperationNotes",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
            procedures: [],
            patient: {},
            completeProcedure: false,
        };
    },

    computed: {

        theProcedure() {
            if(!this.procedures.length) return {};

            return this.procedures.filter(proc => proc.procedureID == this.$route.params.procedureId)[0];
        },
    },

    components: {

        "operation-notes-form": () => import('./notes/Index.vue'),
        "operation-theatre-requests": () => import('./requests/Index.vue'),
        "procedure-billing-tab": () => import('./billing/Index.vue'),
        "discharge-theatre-procedure": () => import('./modals/DischargeTheatre.vue'),
    },

    mounted() {

        this.$root.loading = true;
        Promise.allSettled([ this.fetchProcedures(), this.fetchPatient(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.params.patientID}`

            return this.$http.get(url).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchProcedures() {
            let url = `Theatre/GetPendingProcedures`;
                url += `?VisitNo=${this.$route.params.visitNO}`;

            return this.$http.get(url).then(response => {
                this.procedures = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <div class="w-full flex md:flex-row flex-col">
                    <div class="flex-1">
                        <h5 class="font-semibold text-sm">Operation Notes</h5>
                    </div>
                    <div class="flex-1 text-right">
                        <button 
                            @click.prevent="completeProcedure=true"
                            class="btn-sm btn-info text-xs rounded">
                                <i class="fa fa-redo"></i> Discharge From Theatre</button>
                    </div>
                    <discharge-theatre-procedure 
                        :procedure="theProcedure"
                        :showModal="completeProcedure"
                        @refresh="() => {
                            fetchProcedures();
                            $router.push({
                                name: `theatre.operation-notes.create`,
                                params: {
                                    patientID: $route.params.patientID,
                                    visitNo: $route.params.visitNO,
                                },
                            });
                        }" 
                        @closeModal="completeProcedure=false"
                    />
                </div>
              </template>
              <template v-slot:card-body>
                  <div class="w-full flex md:flex-row sm:flex-col 
                    content-start max-h-screen overflow-auto content-start" 
                    style="height:80vh;">
                        <div class="md:w-3/12 sm:w-full flex flex-wrap content-start px-1">
                            <div class="w-full p-tiny bg-blue-800 mb-1 rounded-t-md">
                                <h5 class="font-bold text-base text-white">Procedures</h5>
                            </div>
                            <div class="w-full overflow-auto">
                                <table class="table">
                                    <thead class="bg-blue-500 text-sm text-white">
                                        <tr class="w-full flex">
                                            <th class="p-tiny w-4/5">Procedure</th>
                                            <th class="p-tiny w-1/5">Select</th>
                                        </tr>
                                    </thead>
                                    <tbody 
                                        class="bg-gray-100 flex flex-col items-center text-xs 
                                            overflow-auto">
                                        <tr class="w-full flex cursor-pointer hover:bg-gray-300"
                                            v-for="(proc, idx) in procedures" :key="idx"
                                            :class="proc.procedureID == $route.params.procedureId ? 
                                                `bg-green-300` : ``"
                                            @click.prevent="() => {
                                                $router.push({ 
                                                    name: `theatre.operation-notes.create.procedure`, 
                                                        params: { 
                                                            procedureId: proc.procedureID,
                                                            itemId: proc.serviceID 
                                                        },
                                                        query: {
                                                            encounterID: proc.encounterID,
                                                        },
                                                    }).then(()=>{}).catch(()=>{});
                                            }">
                                            <td class="p-1 w-4/5">
                                                {{ proc.procedure }}
                                            </td>
                                            <td class="p-1 w-1/5">
                                                <router-link 
                                                    :to="{ 
                                                        name: `theatre.operation-notes.create.procedure`, 
                                                        params: {
                                                            procedureId: proc.procedureID, 
                                                            itemId: proc.serviceID 
                                                        } 
                                                    }" 
                                                    class="btn-sm btn-primary text-xs rounded">
                                                    <i class="fa fa-pen"></i>
                                                </router-link>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="md:w-9/12 sm:w-full flex flex-wrap content-start">
                            <div class="w-full ml-1 sm:my-1">
                                <div class="w-full p-1 bg-blue-700 rounded-t-md">
                                    <h5 class="font-bold text-base text-white">Personal Details</h5>
                                </div>
                                <div class="w-full flex flex-wrap border-2 border-blue-700 rounded-b-md 
                                    overflow-auto" style="max-height:12vh;">
                                    <div class="md:w-1/4 w-1/2 p-tiny">
                                        <h5 class="font-bold text-sm">Name: 
                                            <span class="text-blue-800">{{ patient.names }}</span></h5>
                                    </div>
                                    <div class="md:w-1/4 w-1/2 p-tiny">
                                        <h5 class="font-bold text-sm">Gender: 
                                            <span class="text-blue-800">{{ patient.gender }}</span> </h5>
                                    </div>
                                    <div class="md:w-1/4 w-1/2 p-tiny">
                                        <h5 class="font-bold text-sm">DOB: 
                                            <span class="text-blue-800">
                                                {{ patient.dob | dateFormat }}</span></h5>
                                    </div>
                                    <div class="md:w-1/4 w-1/2 p-tiny">
                                        <h5 class="font-bold text-sm">MRN: <span class="text-blue-700">{{ patient.patienT_ID }}</span> </h5>
                                    </div>
                                    <div class="md:w-1/4 w-1/2 p-tiny">
                                        <h5 class="font-bold text-sm">Visit No: <span class="text-blue-700">{{ patient.visitNo }}</span> </h5>
                                    </div>
                                    <div class="md:w-1/4 w-1/2 p-tiny">
                                        <h5 class="font-bold text-sm">Payment Mode: <span class="text-blue-700">{{ patient.pMode }}</span></h5>
                                    </div>
                                    <div class="md:w-1/4 w-1/2 p-tiny">
                                        <h5 class="font-bold text-sm">Diagnosis:</h5>
                                        <p class="text-xs"></p>
                                    </div>
                                </div>
                            </div>
                            <div class="w-full flex flex-wrap" v-if="$route.params.procedureId">
                                <ul class="w-full flex border-b border-gray-500">
                                    <li class="-mb-px mr-1">
                                        <a @click.prevent="active=0" href="javascript:void(0)" 
                                          class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                                          :class="active === 0 ? activeClass : inActiveClass">Theatre Requests</a>
                                    </li>
                                    <li class="-mb-px mr-1">
                                        <a @click.prevent="active=1" href="javascript:void(0)" 
                                          class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                                          :class="active === 1 ? activeClass : inActiveClass">Operation Details</a>
                                    </li>
                                    <li class="-mb-px mr-1">
                                        <a @click.prevent="active=2" href="javascript:void(0)" 
                                          class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                                          :class="active === 2 ? activeClass : inActiveClass">Billing</a>
                                    </li>
                                </ul>
                                <div class="flex-1" v-if="active===0">
                                    <operation-theatre-requests />
                                </div>
                                <div class="flex-1" v-if="active===1">
                                    <operation-notes-form 
                                        :procedures="procedures"/>
                                </div>
                                <div class="flex-1" v-if="active===2">
                                    <procedure-billing-tab :procedure="theProcedure" />
                                </div>
                            </div>
                            <div v-else class="mx-auto">
                                <div class="w-full mt-4">
                                    <img style="height:45vh; width:80vh;" src="/un-authorized.svg" alt="" srcset="">
                                    <h5 class="text-red-500 font-semibold">Select a procedure to fill the notes</h5>
                                </div>
                            </div>
                        </div>
                      </div>
              </template>
              <template v-slot:card-footer>
                  <div class="text-right">
                      <router-link :to="{ name: `theatre.procedure-queue.index`}" class="btn-sm text-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
                      <!-- <button class="btn-sm text-sm bg-blue-500 whitespace-no-wrap text-white font-bold text-xs"><i class="fa fa-save"></i> Save</button> -->
                  </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
